import { observer } from 'mobx-react-lite'
import useTable from '@ui-components-3/ui/lib/components/Table/hooks/useTable'
import CommonTable from 'components/common/tables/CommonTable/CommonTable'
import { useMemo } from 'react'
import { MemberMedicalHistoryConditionsData } from 'hooks/useMemberMedicalHistoryConditions'
import { TableRowActionsMenu } from '../tables/common'

type ActionItem = {
  label: string
  className?: string
  onClick: (item: MemberMedicalHistoryConditionsData) => void
}

type MedicalHistoryTableProps = {
  data?: MemberMedicalHistoryConditionsData[]
  memberColumnTitle?: string
  actions?: ActionItem[]
}

const MedicalHistoryTable = ({ data, memberColumnTitle = 'Member', actions }: MedicalHistoryTableProps) => {
  const columns = useMemo(() => {
    // TODO - improve columns type
    const baseColumns: any[] = [
      {
        id: 'member',
        header: memberColumnTitle,
        accessorKey: 'member',
        meta: {
          cellClassName: 'w-[250px]',
        },
      },
      {
        id: 'conditions',
        header: 'Conditions',
        accessorKey: 'conditions',
      },
    ]

    if (actions?.length) {
      baseColumns.push({
        id: 'actions',
        header: '',
        cell: (cell: any) => (
          <TableRowActionsMenu aria-label="History actions" actions={actions} rowData={cell?.row?.original} />
        ),
        meta: {
          cellClassName: 'w-[50px]',
        },
      })
    }

    return baseColumns
  }, [actions, memberColumnTitle])

  const table = useTable({
    // using the model with paginationType 'server' without pagination controls and event handlers
    // makes table acting like static table without pagination at all, so we can use all the benefits from
    // useTable hook as well as reuse existing CommonTable component
    paginationType: 'server',
    columns,
    data,
    rowId: 'member',
  })

  if (!data?.length) {
    return null
  }

  return (
    <div className="max-h-[500px] overflow-y-auto">
      <CommonTable
        aria-label="Conditions Table"
        model={table}
        className="w-full typography-body font-medium"
        containerClassName="!min-h-max !basis-auto"
        hideFooter
      />
    </div>
  )
}

export default observer(MedicalHistoryTable)
